import { Controller } from "@hotwired/stimulus";

/**
 * Stimulus controller for coordinating signature form submission
 * Ensures all drawn signatures are converted to files before form submission
 */
export default class extends Controller {
  /**
   * Called before form submission
   * Saves all drawn signatures to their file inputs
   * @param {Event} event - The submit event
   */
  async beforeSubmit(event) {
    // Prevent default to handle async operations
    event.preventDefault();

    // Find all signature-stamp controllers within this form
    const stampControllers = this.element.querySelectorAll(
      '[data-controller="signature-stamp"]'
    );

    const savePromises = [];

    stampControllers.forEach((element) => {
      const controller = this.application.getControllerForElementAndIdentifier(
        element,
        "signature-stamp"
      );

      if (controller && controller.hasDrawnSignature && controller.signaturePad) {
        // Save the drawn signature to the file input
        savePromises.push(controller.saveSignatureToInput());
      }
    });

    if (savePromises.length > 0) {
      try {
        // Wait for all signatures to be saved
        const results = await Promise.all(savePromises);

        // Check if any save failed
        if (results.some((result) => result === false)) {
          alert("Erreur lors de la sauvegarde des signatures");
          return;
        }
      } catch (error) {
        console.error("Error saving signatures:", error);
        alert("Erreur lors de la sauvegarde des signatures");
        return;
      }
    }

    // Now submit the form
    this.element.submit();
  }
}
